<template>
<div v-if="pdfData" id="pdf-container" style="overflow-y: scroll;"></div>
<div v-else>This PDF is not available.</div>
</template>

<script setup>
import { computed, onMounted, watch, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
// import pdfjsLib from 'pdfjs-dist';
import { getDocument, GlobalWorkerOptions } from "pdfjs-dist";
GlobalWorkerOptions.workerSrc =
  "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js";
GlobalWorkerOptions.isEvalSupported = false;
const props = defineProps({
  pdfName: {
    type: String,
    required: true,
  },
});

const store = useStore();
const pdfData = computed(() => store.getters.getDocumentById(props.pdfName));

let context;
let canvas;

watch(
  () => props.pdfName,
  (n, o) => {
    try{
      //alert(document.getElementById("the-canvas"));
      clearCanvas();
      var success = loadPdf();
      //if (!success) loadPdfDefault();
    }
    catch(e){
      console.error(e);
      //now open it another way
      loadPdfDefault();
    }
  }
);

function clearCanvas() {
  context?.clearRect(0, 0, canvas.width, canvas.height);
}

function binaryStringToUint8Array(binaryString) {
  const length = binaryString.length;
  const array = new Uint8Array(new ArrayBuffer(length));
  for (let i = 0; i < length; i++) {
    array[i] = binaryString.charCodeAt(i);
  }
  return array;
}

async function loadPdf() {
  if (!pdfData.value || !pdfData.value.FileBytes) return;

  console.log("📕 ~ loadPdf ~", props.pdfName);

  const reader = new FileReader();
  reader.readAsDataURL(pdfData.value.FileBytes);

  reader.onloadend = async function () {
    try {
      const base64data = reader.result;
      const base64string = base64data.split(",")[1];
      const binaryString = atob(base64string);
      const uint8Array = binaryStringToUint8Array(binaryString);

      const loadingTask = getDocument({ data: uint8Array });
      const pdf = await loadingTask.promise;

      if (pdf) console.log("PDF loaded");

      const container = document.getElementById("pdf-container");
      container.textContent = "";

      // Load all pages asynchronously
      const pagePromises = [];
      for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
        pagePromises.push(pdf.getPage(pageNumber).then((page) => ({ pageNumber, page })));
      }

      const pages = await Promise.all(pagePromises);

      // Render pages in order
      for (const { pageNumber, page } of pages.sort((a, b) => a.pageNumber - b.pageNumber)) {

        const scale = 1.2;
        const viewport = page.getViewport({ scale });

        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        await page.render({ canvasContext: context, viewport }).promise;

        container.appendChild(canvas);
      }
    } catch (error) {
      console.error("Error processing PDF:", error);
    }
  };
}


function loadPdfDefault() {

  if (!pdfData.value) return;

  console.log("📕 ~ loadPdfDefault ~", props.pdfName);

  const reader = new FileReader();
  reader.readAsDataURL(pdfData.value.FileBytes);
  reader.onloadend = function () {
    const base64data = reader.result;
    console.log("base64data:", base64data);

    // Ensure the Base64 string is correctly extracted
    const base64string = base64data.split(",")[1];
    console.log("base64string:", base64string);

    // Decode the Base64 string
    const binaryString = atob(base64string);
    console.log("binaryString:", binaryString);

    // Convert binary string to Uint8Array
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    console.log("Uint8Array:", bytes);

    // Create a Blob from the Uint8Array
    const blob = new Blob([bytes], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    // Open the PDF in a new tab
    window.open(url, '_blank');
  };
}

try{
  var success = loadPdf();
  //if (!success) loadPdfDefault();
}
catch(e){
  console.error(e);
  loadPdfDefault();
}

onBeforeUnmount(() => {
  // Your function here...
  console.log("Component is about to be destroyed");
  if (context) {
    context.clearRect(0, 0, canvas.width, canvas.height);
    console.log("PDF removed and component is about to be destroyed");
  }
});
</script>
